import React from 'react';
import { Tag, Tooltip } from 'antd';
import { LockOutlined, EyeOutlined } from '@ant-design/icons';

interface ReadOnlyBadgeProps {
  compact?: boolean;
  tooltip?: string;
  iconOnly?: boolean;
  className?: string;
  style?: React.CSSProperties;
}


export const ReadOnlyBadge: React.FC<ReadOnlyBadgeProps> = ({
  compact = false,
  tooltip = 'У вас нет прав на редактирование этих данных',
  iconOnly = false,
  className,
  style,
}) => {
  const badge = (
    <Tag
      icon={<LockOutlined />}
      color="default"
      className={className}
      style={{
        margin: 0,
        cursor: 'help',
        userSelect: 'none',
        ...style,
      }}
    >
      {!iconOnly && (compact ? 'Чтение' : 'Только чтение')}
    </Tag>
  );

  return (
    <Tooltip title={tooltip} placement="top">
      {badge}
    </Tooltip>
  );
};

export const ViewOnlyBadge: React.FC<ReadOnlyBadgeProps> = ({
  compact = false,
  tooltip = 'У вас нет прав на удаление данных',
  iconOnly = false,
  className,
  style,
}) => {
  const badge = (
    <Tag
      icon={<EyeOutlined />}
      color="blue"
      className={className}
      style={{
        margin: 0,
        cursor: 'help',
        userSelect: 'none',
        ...style,
      }}
    >
      {!iconOnly && (compact ? 'Просмотр' : 'Без удаления')}
    </Tag>
  );

  return (
    <Tooltip title={tooltip} placement="top">
      {badge}
    </Tooltip>
  );
};

interface RbacStatusBadgeProps {
  canWrite: boolean;
  canDelete: boolean;
  compact?: boolean;
  iconOnly?: boolean;
  hideOnFullAccess?: boolean;
}

export const RbacStatusBadge: React.FC<RbacStatusBadgeProps> = ({
  canWrite,
  canDelete,
  compact = false,
  iconOnly = false,
  hideOnFullAccess = true,
}) => {
  if (canWrite && canDelete && hideOnFullAccess) {
    return null;
  }

  if (!canWrite) {
    return <ReadOnlyBadge compact={compact} iconOnly={iconOnly} />;
  }

  if (!canDelete) {
    return <ViewOnlyBadge compact={compact} iconOnly={iconOnly} />;
  }

  return null;
};


